export const customStyles = ({
  z1 = 50,
  z2 = 52,
  maxHeight = "auto",
}: {
  z1?: number;
  z2?: number;
  maxHeight: number | string;
}) => {
  return {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.3)", // color base
      backdropFilter: "blur(0.5px)", // desenfoque
      zIndex: z1,
    },
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      overFlowY: "auto",
      boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.25)",
      transform: "translate(-50%, -50%)",
      zIndex: z2,
      maxHeight,
    },
  };
};

export const calendarModalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.3)", // color base
    backdropFilter: "blur(0.5px)", // desenfoque
    zIndex: 46,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "90%",
    height: "90%",
    marginRight: "-50%",
    padding: 0,
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.25)",
    transform: "translate(-50%, -50%)",
    zIndex: 47,
  },
};

export const documentModalStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.3)", // color base
    backdropFilter: "blur(0.5px)", // desenfoque
    zIndex: 48,
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    width: "90%",
    height: "90%",
    marginRight: "-50%",
    padding: 0,
    boxShadow: "0px 10px 30px rgba(0, 0, 0, 0.25)",
    transform: "translate(-50%, -50%)",
    zIndex: 49,
  },
};
